const AppSwitchIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none">
    <path
      fill="#42055F"
      d="M0 2.26A2.25 2.25 0 0 1 2.25.01h3.09a2.25 2.25 0 0 1 2.25 2.25v3.09A2.25 2.25 0 0 1 5.34 7.6H2.25A2.25 2.25 0 0 1 0 5.35V2.26ZM10.41 2.26A2.25 2.25 0 0 1 12.66.01h3.09A2.25 2.25 0 0 1 18 2.26v3.09a2.25 2.25 0 0 1-2.25 2.25h-3.09a2.25 2.25 0 0 1-2.25-2.25V2.26ZM0 12.66a2.25 2.25 0 0 1 2.25-2.25h3.09a2.25 2.25 0 0 1 2.25 2.25v3.09A2.25 2.25 0 0 1 5.34 18H2.25A2.25 2.25 0 0 1 0 15.75v-3.09ZM10.41 12.66a2.25 2.25 0 0 1 2.25-2.25h3.09A2.25 2.25 0 0 1 18 12.66v3.09A2.25 2.25 0 0 1 15.75 18h-3.09a2.25 2.25 0 0 1-2.25-2.25v-3.09Z"
    />
  </svg>
);
export default AppSwitchIcon;
